import { SentimentBadge } from "@aircall/blocks";
import { SentimentHeader } from "@/playground/components/DevHome/table/components/SentimentHeader/SentimentHeader";
import type { SentimentValue } from "@/playground/components/DevHome/table/graphql/types";
import type { RowData } from "@/playground/components/DevHome/table/pages/conversation_center/components/Table/Table.decl";
import type { ColumnType } from "../columns.decl";

// Map the uppercase SentimentValue to the badge's lowercase sentiment; anything
// other than positive/negative falls back to the neutral variant.
function toBadgeSentiment(
  sentiment: SentimentValue
): "positive" | "negative" | "neutral" {
  switch (sentiment) {
    case "POSITIVE":
      return "positive";
    case "NEGATIVE":
      return "negative";
    default:
      return "neutral";
  }
}

function SentimentDataCell({ sentiment, type }: RowData) {
  if (type === "VOICEMAIL" || !sentiment) {
    return null;
  }

  return <SentimentBadge sentiment={toBadgeSentiment(sentiment)} />;
}

export const sentimentConfig: ColumnType = {
  id: "sentiment",
  label: <SentimentHeader />,
  renderer: SentimentDataCell,
};
